module.exports = __webpack_public_path__ + "static/media/zm.5ac3774a.svg";